import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <div className="cookie-icon">
          <Cookie size={24} />
        </div>
        <div className="cookie-text">
          <p className="body-md">
            Nous utilisons des cookies pour améliorer votre expérience sur notre
            site.
          </p>
        </div>
        <button className="btn-primary" onClick={acceptCookies}>
          Accepter
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
